import HomeWidget from "./HomeWidget.vue";
import FullExtentWidget from "./FullExtentWidget.vue";
import SearchWidget from "./SearchWidget.vue";
import DatasetWidget from "./DatasetWidget.vue";
import OtherWidget from "./OtherWidget.vue";

export { HomeWidget, FullExtentWidget, SearchWidget, DatasetWidget, OtherWidget };
